import React from 'react';
import Toaster from 'Components/Toaster';

export default () => {
  return <Toaster/>;
};
